/**
 * Deutsche Texte. Die führende Sprache — Englisch wird daraus abgeleitet, nicht
 * umgekehrt.
 *
 * Die Schlüssel folgen dem Aufbau `bereich.gegenstand.eigenschaft`. Fachbegriffe
 * stehen so, wie sie im Glossar (`docs/domain/glossary.md`) festgelegt sind:
 * „Zähler", nicht „Messgerät"; „Messstelle", nicht „Zählpunkt".
 */
export const de = {
  "quantity.consumption": "Verbrauch",
  "quantity.grid_import": "Netzbezug",
  "quantity.grid_export": "Einspeisung",
  "quantity.generation": "Erzeugung",
  "quantity.self_consumption": "Eigenverbrauch",
  "quantity.autarky_ratio": "Autarkiegrad",
  "quantity.self_consumption_ratio": "Eigenverbrauchsquote",
  "quantity.common_area": "Allgemeinstrom",
  "quantity.unit_consumption": "Verbrauch Wohneinheit",
  "quantity.unit_pv_share": "PV-Anteil Wohneinheit",
  "quantity.unit_grid_share": "Netzanteil Wohneinheit",
  "quantity.load_consumption": "Verbrauch Verbraucher",
  "quantity.load_pv_share": "PV-Anteil Verbraucher",
  "quantity.residual_consumption": "Übriger Verbrauch",
  "quantity.storage_charge": "Ladung Speicher",
  "quantity.storage_discharge": "Entladung Speicher",
  "generationAsset.kind.pv": "PV-Anlage",
  "generationAsset.kind.battery": "Speicher",
  "consumer.kind.common_area": "Allgemeinstrom",
  "consumer.kind.heat_pump": "Wärmepumpe",
  "consumer.kind.wallbox": "Wallbox",
  "consumer.kind.other": "Sonstiger Verbraucher",
  "consumer.position.before_own_unit": "vor der selbstgenutzten Wohneinheit",
  "consumer.position.behind_own_unit": "hinter der selbstgenutzten Wohneinheit",
  "distribution.dynamic": "Dynamische Verteilung",
  "distribution.dynamic.description":
    "Je Viertelstunde bekommt jede Wohneinheit den Teil des PV-Stroms, der ihrem Anteil am gleichzeitigen Verbrauch entspricht. Bildet die Gleichzeitigkeit genau ab und lässt nichts liegen — ein großer Verbraucher verdrängt die kleinen aber auch in der Abrechnung.",
  "distribution.equal_fill": "Gleichverteilung mit Umverteilung des Rests",
  "distribution.equal_fill.description":
    "Je Viertelstunde zunächst zu gleichen Teilen auf alle; wer weniger verbraucht als seinen Teil, bekommt nur seinen Verbrauch, und der Rest geht an die, deren Bedarf noch offen ist. Jeder hat einen Sockel, die Einspeisung ist dieselbe. Kein Anbieter führt dafür einen Namen — das Verfahren muss im Vertrag ausformuliert sein.",
  "distribution.annual_sum": "Summenzählermodell (VBEW)",
  "distribution.annual_sum.description":
    "Vereinfachte Bilanzierung: Bekannt ist nur, wie viel PV-Strom im Gebäude geblieben ist, nicht wo. Diese Menge wird nach dem Anteil am Verbrauch des Abrechnungszeitraums verteilt — ohne Viertelstundenwerte und blind für den Zeitpunkt. Für die gemeinschaftliche Gebäudeversorgung nach § 42b EnWG nicht zugelassen.",

  "role.energy_import_total": "Bezug gesamt",
  "role.energy_import_t1": "Bezug Tarif 1",
  "role.energy_import_t2": "Bezug Tarif 2",
  "role.energy_export_total": "Einspeisung gesamt",
  "role.power_total": "Momentanleistung",
  "role.power_l1": "Leistung L1",
  "role.power_l2": "Leistung L2",
  "role.power_l3": "Leistung L3",
  "role.voltage_l1": "Spannung L1",
  "role.voltage_l2": "Spannung L2",
  "role.voltage_l3": "Spannung L3",
  "role.current_l1": "Strom L1",
  "role.current_l2": "Strom L2",
  "role.current_l3": "Strom L3",
  "role.heat_energy": "Wärmemenge",
  "role.heat_power": "Wärmeleistung",
  "role.volume": "Volumen",
  "role.volume_flow": "Durchfluss",
  "role.temperature_flow": "Vorlauftemperatur",
  "role.temperature_return": "Rücklauftemperatur",
  "role.temperature_difference": "Temperaturspreizung",

  "meter.status.draft": "Unvollständig",
  "meter.status.active": "Aktiv",
  "meter.status.replaced": "Ersetzt",
  "meter.status.archived": "Archiviert",
  "meter.number.missing": "Zählernummer fehlt",
  "meter.number.hint":
    "Der Zähler sammelt bereits Daten. Für Auswertungen und Abrechnungen fehlt noch die Zählernummer vom Typenschild.",

  "meter_change.pending.title": "Zählerwechsel erkannt",
  "meter_change.pending.body":
    "An dieser Messstelle scheint ein anderer Zähler zu hängen. Bitte bestätigen und die neue Zählernummer eintragen.",
  "meter_change.confirm": "Wechsel bestätigen",
  "meter_change.reject": "Kein Wechsel",

  "integration.cts_cloud.title": "CTS-Geräte über die HausMeter-Cloud",
  "integration.cts_cloud.description":
    "Das Gerät sendet seine Werte an HausMeter. Historie über Jahre, Auswertung über mehrere Geräte.",
  "integration.cts_local.title": "CTS-Gerät im eigenen Netz",
  "integration.cts_local.description":
    "Die App spricht direkt mit dem Gerät. Es sendet nichts nach außen — dafür hält es nur wenige Tage Historie.",
  "integration.manual_input.title": "Zählerstände von Hand",
  "integration.manual_input.description":
    "Ohne Gerät: Zählerstände selbst eintragen. Auch als Rückfall, wenn ein Gerät ausfällt.",

  "setup.claim.title": "Gerät zuordnen",
  "setup.confirm.title": "Bestätigen",
  "setup.discover.title": "Gerät suchen",
  "setup.ble.title": "Über Bluetooth einrichten",
  "setup.softap.title": "Über das Gerätenetz einrichten",
  "setup.form.title": "Angaben",

  "mode.cloud": "Cloud",
  "mode.local": "Nur lokal",
  "mode.hybrid": "Lokal und Cloud",
  "mode.local.hint":
    "Live-Werte kommen direkt vom Gerät. Historie über mehrere Tage und Messkonzepte gibt es nur mit Cloud-Anbindung.",

  "series.gap": "Keine Daten",
  "series.quality.interpolated": "Geschätzter Wert",
  "series.quality.suspect": "Wert unplausibel",

  "error.auth.required": "Bitte anmelden.",
  "error.auth.forbidden": "Dafür fehlt die Berechtigung.",
  "error.resource.not_found": "Nicht gefunden.",
  "error.resource.conflict": "Das gibt es schon.",
  "error.feature.not_implemented": "Diese Funktion wird gerade gebaut.",
  "error.internal.error": "Da ist etwas schiefgegangen. Bitte später erneut versuchen.",
  "error.network": "Keine Verbindung.",
} as const;

export type TranslationKey = keyof typeof de;
